// Globals
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { getRegions, regionToggleActive } from '../../feature';
import { regionsSelector } from '../../feature/selectors';

// Components
import {
  StyledPageTitle,
  StyledTabTitleWrapper,
  StyledContentBlock,
  StyledPageDescription,
} from '../../components/Styled';
import RegionsList from '../../components/RegionsList/RegionsList';

// Modules
import { Resource, usePermissions } from '@/modules/Permissions';

// Helpers
import { usePagination } from '@/hooks';

const RegionsContainer = () => {
  const { t } = useTranslation(['regions']);
  const dispatch = useAppDispatch();
  const { regions, isLoading } = useAppState(regionsSelector);
  const { currentPage, onPageChange } = usePagination();
  const { canManage } = usePermissions();

  useEffect(() => {
    dispatch(getRegions({ page: currentPage, per_page: 10 }));
  }, [currentPage]);

  const onStatusChange = (id: string) => {
    dispatch(regionToggleActive(id));
  };

  return (
    <>
      <StyledTabTitleWrapper>
        <StyledPageTitle>{t('regions_tab_title')}</StyledPageTitle>
        <StyledPageDescription>{t('regions_tab_description')}</StyledPageDescription>
      </StyledTabTitleWrapper>
      <StyledContentBlock>
        <RegionsList
          isLoading={isLoading}
          currentPage={currentPage}
          onPageChange={onPageChange}
          total={regions?.meta?.total ?? 0}
          regionsList={regions?.data ?? []}
          onStatusChange={onStatusChange}
          canManage={canManage(Resource.REGION)}
        />
      </StyledContentBlock>
    </>
  );
};

export default RegionsContainer;
